/** @format */

import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Form, Icon, Header } from 'semantic-ui-react';
import intl from 'react-intl-universal';
import { partConditions } from '../../../../../models/parts';

@inject('UserStore', 'RequestsStore', 'ClientsStore', 'CarPartsStore')
@observer
class NewEditRequestPartOption extends Component {
  renderButton = () => {
    const { RequestsStore } = this.props;
    if (RequestsStore.requestsParams.reqOptionForm.currentOptionId === null) {
      return (
        <Form.Button type="submit" color="green" fluid>
          <Icon name="plus" /> {intl.get('parts.add_option')}
        </Form.Button>
      );
    } else {
      return (
        <Form.Button type="submit" color="green" fluid>
          <Icon name="save" /> {intl.get('general.save_updates')}
        </Form.Button>
      );
    }
  };
  render() {
    const { RequestsStore } = this.props;
    return (
      <Modal open={RequestsStore.requestsParams.reqOptionForm.open}>
        <Modal.Content>
          <Header className="modal-header" as="h3">
            {intl.get('parts.labels.new_option')}
          </Header>
          <div className="header-spacer"></div>
          <Form
            className="modal-form"
            size="small"
            onSubmit={() => {
              RequestsStore.handlePartOptionFormSubmit(
                RequestsStore.requestsParams.currentRequestId,
              );
              RequestsStore.toggleOptionForm();
            }}
          >
            <Form.Group widths="equal">
              <Form.Select
                search
                selectOnNavigation={false}
                onChange={(e, input) =>
                  RequestsStore.handlePartOptionInput(input.value, input.name)
                }
                onFocus={() =>
                  RequestsStore.resetErrorReqPartOption('conditions')
                }
                error={RequestsStore.requestsErrors.reqPartOption.includes(
                  'conditions',
                )}
                name="conditions"
                value={RequestsStore.currentReqPartOption.data.conditions}
                options={partConditions}
                fluid
                label={intl.get('parts.labels.part_conditions')}
                placeholder={intl.get('parts.labels.part_conditions')}
              ></Form.Select>
              <Form.Input
                autoComplete="off"
                onChange={(e, input) =>
                  RequestsStore.handlePartOptionInput(input.value, input.name)
                }
                name="color"
                value={RequestsStore.currentReqPartOption.data.color}
                fluid
                label={intl.get('parts.labels.part_color')}
                placeholder={intl.get('parts.labels.part_color')}
              ></Form.Input>
              <Form.Input
                autoComplete="off"
                onChange={(e, input) =>
                  RequestsStore.handlePartOptionInput(input.value, input.name)
                }
                name="position"
                value={RequestsStore.currentReqPartOption.data.position}
                fluid
                label={intl.get('parts.labels.part_shelf_position')}
                placeholder={intl.get('parts.labels.part_shelf_position')}
              ></Form.Input>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                autoComplete="off"
                onChange={(e, input) =>
                  RequestsStore.handlePartOptionInput(input.value, input.name)
                }
                name="internalCode"
                value={RequestsStore.currentReqPartOption.data.internalCode}
                fluid
                label={intl.get('parts.labels.part_internal_code')}
                placeholder={intl.get('parts.labels.part_internal_code')}
              ></Form.Input>
              <Form.Input
                autoComplete="off"
                onChange={(e, input) =>
                  RequestsStore.handlePartOptionInput(input.value, input.name)
                }
                type="number"
                onFocus={() => RequestsStore.resetErrorReqPartOption('price')}
                error={RequestsStore.requestsErrors.reqPartOption.includes(
                  'price',
                )}
                onBlur={() => RequestsStore.formatPartOptionPrice()}
                name="price"
                value={RequestsStore.currentReqPartOption.data.price}
                fluid
                label={intl.get('parts.labels.part_price')}
                placeholder={intl.get('parts.labels.part_price')}
              ></Form.Input>
            </Form.Group>
            <Form.Group widths="equal">
              <Form.TextArea
                autoComplete="off"
                onChange={(e, input) =>
                  RequestsStore.handlePartOptionInput(input.value, input.name)
                }
                name="notes"
                value={RequestsStore.currentReqPartOption.data.notes}
                label={intl.get('parts.labels.request_notes')}
                placeholder={intl.get('parts.labels.request_notes')}
              ></Form.TextArea>
            </Form.Group>
            {this.renderButton()}
          </Form>
          <div
            className="close-button"
            onClick={() => {
              RequestsStore.toggleOptionForm();
              RequestsStore.resetCurrentOption();
            }}
          >
            X
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default NewEditRequestPartOption;
